import React from 'react';
import { ValorantAccountSelector } from '../../components/ValorantAccountSelector/ValorantAccountSelector';
import {BreadcrumbReact} from "../../components/packages/BreadcrumbReact";

export const ValorantAccountPage = (props) => {
  const { valorantPackage: { ranked, rank_tier, name }} = props;

  const elements = [
    { name: 'Home', url: 'https://www.unrankedsmurfs.com/' },
    { name: 'Valorant', url: 'https://www.unrankedsmurfs.com/valorant' },
    { name: `${ranked ? 'ranked' : 'unranked'} Valorant Accounts`, url: `/valorant/valorant-account/category/${ranked ? 'ranked' : 'unranked'}` },
  ];

  if(ranked) {
    elements.push({ name: rank_tier, url: `/valorant/valorant-account/category/ranked/${rank_tier}` })
  }

  elements.push({ name: name, url: null })

  return (

    <div className="valorant-unranked-account">
      <BreadcrumbReact elements={elements} className="mb-4"/>
      <img
        className="valorant-unranked-account__credit-card"
        src="/images/valorant/valorant_credit_cards.png"
      />

      <ValorantAccountSelector {...props} />
      <div className="valorant-unranked-account__static-section">

        <img
          src="/images/valorant/valorant_account_static_section_bg.png"
          className="valorant-unranked-account__static-section-bg"
        />

        <div className="valorant-unranked-account__static-section-grid">
          <StaticSectionGridItem
            icon="/images/valorant/icons/aftershock.svg"
            heading={props.valorantPackage.product_features?.[0]?.title || 'Instantly eligible for Ranked queue'}
            description={props.valorantPackage.product_features?.[0]?.description || 'All our accounts are above level 20 so you can instantly queue up for ranked mode without waiting or grinding normal games. Play with your friends now.'}
          />
          <StaticSectionGridItem
            icon="/images/valorant/icons/arrow_up.svg"
            heading={props.valorantPackage.product_features?.[1]?.title || 'FREE LIFETIME GUARANTEE'}
            description={props.valorantPackage.product_features?.[1]?.description || 'If something happens to your Valorant account, you\'re covered by our guarantee. This means we\'ll replace it. Find out more here.'}
          />
          <StaticSectionGridItem
            icon="/images/valorant/icons/healing_orb.svg"
            heading={props.valorantPackage.product_features?.[2]?.title || 'Choose your agent'}
            description={props.valorantPackage.product_features?.[2]?.description || 'Choose your agent. Grinding a new agent takes time so we allow you to choose from already unlocked agents. You can choose up to 3 agents'}
          />
          <StaticSectionGridItem
            icon="/images/valorant/icons/beacon.svg"
            heading={props.valorantPackage.product_features?.[3]?.title || 'SAFE & SECURE PAYMENT'}
            description={props.valorantPackage.product_features?.[3]?.description || 'Our site is secured using SSL technology and uses secure gateways for payment processing. We also provide full recovery details on all accounts.'}
          />
          <StaticSectionGridItem
            icon="/images/valorant/icons/tailwind.svg"
            heading={props.valorantPackage.product_features?.[4]?.title || '24/7 INSTANT DELIVERY'}
            description={props.valorantPackage.product_features?.[4]?.description || 'When you buy a Valorant Smurf account from us it will be delivered instantly after completing your purchase on screen and via email.'}
          />
          <StaticSectionGridItem
            icon="/images/valorant/icons/arrow.svg"
            heading={props.valorantPackage.product_features?.[5]?.title || 'RATED 5 STARS'}
            description={props.valorantPackage.product_features?.[5]?.description || 'UnrankedSmurfs has a proud history of providing quality accounts and excellent service. We have over 5000 verified reviews and are rated 5 stars.'}
          />
        </div>


        {props.valorantPackage.product_description ? <p dangerouslySetInnerHTML={{ __html: props.valorantPackage.product_description }}></p> : (
          <>
            <h6 className="valorant-unranked-account__heading text-xs font-semibold leading-none">
              Why buy {props.valorantPackage.ranked ? 'Ranked' : 'Unranked'}{' '}
              Valorant Account from UnrankedSmurfs?
            </h6>
            <p className="valorant-unranked-account__paragraph">
            UnrankedSmurfs is the largest specialised store with League of Legends
            and Valorant accounts. So, you can rest certain that you are not
            buying your account from some sketchy individual on the dark web;
            rather, you are dealing with a legitimate business. We have hundreds
            of accounts in stock, therefore we nearly always have what you need.
            If you can't find what you're searching for, please send us a note and
            we will do our best to make you happy.
            </p>

            <h6 className="valorant-unranked-account__heading text-xs font-semibold leading-none">
            Account safety should be your top priority while using a Valorant
            account.
            </h6>
            <p className="valorant-unranked-account__paragraph">
            The last thing you want is a low-quality botted account that gets
            banned for no reason after you've spent hours climbing the ranks. We
            provide a free, permanent guarantee on all the accounts we make, and
            each one is expertly crafted and leveled by hand by our team of
            account creators. UnrankedSmurfs accounts are forever try what
            thousands of customers vouch for!
            </p>
          </>
        )}
      </div>
    </div>
  );
};

const StaticSectionGridItem = ({ icon, heading, description }) => (
  <div className="valorant-unranked-account__static-section-grid-item">
    <img
      className="valorant-unranked-account__static-section-image"
      src={icon}
      alt=""
    />
    <div>
      <h6 className="valorant-unranked-account__static-section-grid-heading text-xs font-semibold leading-none">
        {heading}
      </h6>
      <p className="valorant-unranked-account__static-section-grid-description">
        {description}
      </p>
    </div>
  </div>
);
